import * as echarts from "echarts"
import EChartsController from "../echarts_controller"
import { world, countries } from "../world_topology"

export default class extends EChartsController {
  static values = {
    data: { type: Array, default: [] },
  }

  initialize() {
    echarts.registerMap("world", world)
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)

    const validCountries = countries.filter((country) => country.code != null)
    const validCountryCodes = new Set(
      validCountries.map((country) => country.code.toLowerCase()),
    )
    const validThreatSources = this.dataValue.filter((threatSource) =>
      validCountryCodes.has(threatSource.country_code),
    )
    const threatSources = validThreatSources.map((threatSource) => {
      const { name: country_name } = validCountries.find(
        (country) => country.code.toLowerCase() === threatSource.country_code,
      )

      return {
        ...threatSource,
        country_name,
      }
    })

    this.renderChart(this.chart, threatSources)
  }

  renderChart(chart, threatSources) {
    chart.setOption({
      geo: {
        type: "map",
        map: "world",
        regions: threatSources.map(({ country_name }) => ({
          name: country_name,
          itemStyle: {
            areaColor: "#627C8580",
          },
        })),
        itemStyle: {
          areaColor: "#627C8514",
          borderColor: "#3B484C",
          borderWidth: 0.5,
        },
        emphasis: {
          label: {
            show: false,
          },
          itemStyle: {
            areaColor: "#627C8580",
            opacity: 0.6,
          },
        },
        select: false,
      },
    })

    const getOption = (geo) => {
      const threatSourcesWithCoord = threatSources.map((threatSource) => {
        const center =
          geo.getRegion(threatSource.country_name)?.getCenter() || []

        return {
          ...threatSource,
          coord: [center[0], center[1]],
        }
      })

      return {
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "Threats",
            type: "map",
            geoIndex: 0,
            data: threatSources.map(({ country_name, events_count }) => {
              return {
                name: country_name,
                value: events_count,
              }
            }),
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            geoIndex: 0,
            silent: true,
            rippleEffect: {
              period: 4,
              scale: 6,
              number: 1,
              brushType: "stroke",
            },
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              color: "#F05252",
              borderWidth: 0,
            },
            data: threatSourcesWithCoord.map(({ coord }) => ({
              value: coord,
            })),
          },
          {
            name: "Threats",
            type: "scatter",
            coordinateSystem: "geo",
            geoIndex: 0,
            silent: true,
            markPoint: {
              symbol: "circle",
              symbolSize: 10,
              label: {
                show: false,
              },
              itemStyle: {
                color: "transparent",
                borderColor: "#E64E1C",
                borderWidth: 2,
              },
              data: threatSourcesWithCoord.map(({ coord }) => ({
                coord,
              })),
            },
            label: {
              show: false,
            },
          },
        ],
      }
    }

    const mapOption = getOption(
      chart.getModel().getComponent("geo").coordinateSystem,
    )
    chart.setOption(mapOption)
  }
}
